export default __webpack_public_path__ + "static/media/White_pharos_logoHorizontal_Retina_alpha.ce4cbfa0.png";